var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.667 13.333h1.187L11 5.188 9.813 4l-8.146 8.146zM.833 15a.8.8 0 0 1-.593-.24.8.8 0 0 1-.24-.593v-2.021a1.65 1.65 0 0 1 .48-1.167L11 .48q.25-.229.552-.354T12.188 0t.645.125q.314.125.542.375l1.146 1.167q.25.228.364.541a1.8 1.8 0 0 1 0 1.26 1.6 1.6 0 0 1-.364.553l-10.5 10.5q-.23.229-.531.354a1.7 1.7 0 0 1-.636.125zm9.563-10.396L9.812 4 11 5.188z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameIcon);
export default __webpack_public_path__ + "static/media/rename_icon.9152975dd12870f7563e2a8e448f6f8f.svg";
export { ForwardRef as ReactComponent };